import PropertyMap from "features/properties/map";

function MapTab({ propertyId }: { propertyId: number }) {
  return <PropertyMap propertyId={propertyId} />;
}

export default MapTab;
